exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.admin-title{border:none;outline:none;background:none;margin-left:20px;margin-bottom:9px;font-weight:700;font-size:14px;color:#0696d7;padding-top:2px;font-family:artifaktElementRegular!important}.table-data-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.invoice-tab-table-container{background-color:#fff;padding:10px 15px;min-height:150px}.po-modal-title{font-size:22px;color:#000;font-family:artifaktElementBold!important}", ""]);

// exports
